<template>
    <div>
        Acerca de la aplicacion.
    </div>
</template>